module.exports = __webpack_public_path__ + "static/media/Suman Ojha_1 .4d47e419.pdf";